<template>
  <div class="progress">
    <div class="text">
      Kérdés {{ $store.state.currentStep }}/{{ $store.state.maxStep-1 }}
    </div>
    <div class="bar">
      <div class="barinner">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress {
  display: flex;
  margin: 50px auto 20px auto;
  width: 70vw;
  align-items: center;
}
.text {
  flex-basis: 115px;
  font-size: 17px;
  color: #003781;
  text-transform: uppercase;
  font-family: "AllianzNeo-Bold", sans-serif;
}
.bar {
  flex-basis: calc(100% - 115px);
  height: 15px;
  background-color: #ffd2dc;
  display: flex;
}
.barinner {
  background-color: #ff92a7;
  /*transition: flex-basis 200ms linear;*/
}
@media screen and (max-width: 767px) {
  .progress {
    margin: 20px auto 10px auto;
    width: calc(100vw - 60px);
  }
}
</style>
